import AjaxLoad from '../../lib/ajax-load';
import { getOffset, smoothScrollTo } from '../../js/helper';

class AppOverview {
    constructor (element, options) {
        this.$appOverview = element;
        this.$form = element.querySelector('[data-overview="form"]');
        this.$overview = element.querySelector('[data-overview="main"]');
        this.$target = element.querySelector('[data-overview="target"]');
        this.formURL = this.$form.getAttribute('action');
        this.customEvent = new CustomEvent('ajaxload');
        this.$sidebar = element.querySelector('[data-overview="sidebar"]');

        this.$pagination = this.$appOverview.querySelector('[data-app-overview="pagination"]');

        const settings = {
            onSubmitted: null
        };

        if (this.formURL === '') {
            this.formURL = location.pathname;
        }

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$target.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-teaser-grid-pagination') === 'url') {
                e.preventDefault();
                this.loadContent(this.formURL, 'GET', e.target.href.split('?')[1]);
            }
        });

        this.$target.addEventListener('change', (e) => {
            e.preventDefault();
            if (e.target.getAttribute('data-teaser-grid-pagination') === 'select') {
                if (e.target.value !== '') {
                    this.loadContent(this.formURL, 'GET', e.target.value.split('?')[1]);
                }
            }
        });

        this.$form.addEventListener('change', (e) => {
            e.preventDefault();
            if (e.target.getAttribute('data-teaser-grid-pagination') !== 'select' &&
            e.target.getAttribute('data-product-overview') !== 'accordion' &&
            e.target.getAttribute('data-teaser-grid-pagination') !== 'select') {
                this.disableFilter();
                this.loadContent(this.formURL, 'POST');
            }
        });

        // History Event Listener
        window.addEventListener('popstate', (e) => {
            if (e.state !== null) {
                if (e.state.type === 'ajax' || e.state.type === 'initial') {
                    location.replace(window.location.href);
                }
            } else {
                location.replace(window.location.href);
            }
        });

        this.bindResetEvent(this.$appOverview);
    }

    bindResetEvent ($content) {
        const $filterResets = $content.querySelectorAll('[data-filter-reset]');

        for (let i = 0; i < $filterResets.length; i++) {
            const $filterReset = $filterResets[i];

            $filterReset.addEventListener('click', () => {
                this.resetFilterForm();
            });
        }
    }

    loadContent (url, method, page) {
        this.$overview.classList.add('is--loading');
        smoothScrollTo(0, getOffset(this.$overview).top - 150, 500);

        const formData = new FormData(this.$form);

        if (typeof page !== 'undefined') {
            let nextPage;

            if (page.indexOf('&') !== -1) {
                const parameters = page.split('&');

                parameters.forEach((value) => {
                    if (value.indexOf('page') !== -1) {
                        nextPage = value.split('=')[1];
                    }
                });
            } else {
                nextPage = page.split('=')[1];
            }

            if (method.toUpperCase() === 'GET') {
                formData.append('page', nextPage);
                method = 'POST';
            }
        }

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: method,
            requestData: formData,
            onSuccess: (resultText) => {
                this.setContent(this.createElementFromHTML(resultText), () => {
                    this.enableFilter();
                    setTimeout(() => {
                        this.$overview.classList.remove('is--finished');
                    }, 350);

                    history.pushState({ type: 'ajax' }, null, window.location.href);
                    history.replaceState({ type: 'ajax' }, null, window.location.href.split('?')[0] + '?' + this.serializeForm(this.$form));

                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.$target);
                        this.bindResetEvent(this.$target);
                    }
                });
            }
        });

        ajaxLoad.initialize();
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);
            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    disableFilter () {
        this.$form.classList.add('is--disabled');
        const $inputs = [].slice.call(this.$sidebar.querySelectorAll('input[type="checkbox"]:not([value=""]):not([data-product-overview="accordion"]):not([disabled]):not(:checked)'));
        $inputs.forEach((input) => {
            input.disabled = true;
        });
    }

    enableFilter () {
        this.$form.classList.remove('is--disabled');

        const $inputs = [].slice.call(this.$sidebar.querySelectorAll('input[type="checkbox"][disabled]:not([value=""]):not([data-product-overview="accordion"])'));
        $inputs.forEach((input) => {
            input.disabled = false;
        });
    }

    setContent (resultText, callback) {
        const $newTeaser = [].slice.call(resultText.querySelectorAll('[data-overview="item"]'));
        let $nowTeaser = [];
        const $oldTeaser = [].slice.call(this.$target.querySelectorAll('[data-overview="item"]'));

        for (const element of $oldTeaser) {
            if (element.classList.contains('is--visible')) {
                element.classList.remove('is--visible');
            } else {
                element.classList.add('is--hidden');
            }
        }

        for (const element of $newTeaser) {
            element.classList.add('is--hidden');
        }

        setTimeout(() => {
            this.$target.innerHTML = resultText.innerHTML;
        }, 250 + ($newTeaser.length * 70));

        setTimeout(() => {
            $nowTeaser = [].slice.call(this.$target.querySelectorAll('[data-overview="item"]'));
            for (const element of $nowTeaser) {
                element.classList.add('is--visible');
            }
        }, 300 + ($newTeaser.length * 70));

        setTimeout(() => {
            this.$overview.classList.add('is--finished');
            this.$overview.classList.remove('is--loading');
            window.dispatchEvent(this.customEvent);
            smoothScrollTo(0, getOffset(this.$overview).top - 120, 750);

            for (const element of $nowTeaser) {
                element.classList.remove('is--hidden');
                element.classList.remove('is--visible');
            }

            if (typeof callback === 'function') {
                callback();
            }
        }, 1100 + ($newTeaser.length * 70));
    }

    resetFilterForm () {
        if (!this.$sidebar) {
            return false;
        }

        const $$checkboxes = this.$sidebar.querySelectorAll('input[type="checkbox"]:not([data-product-overview="accordion"])');
        // control variable to check if there were any checked checkboxes to prevent ajax load when no boxes are checked
        let hasCheckedCheckbox = false;

        for (let i = 0; i < $$checkboxes.length; i++) {
            const $checkbox = $$checkboxes[i];

            if ($checkbox.checked) {
                hasCheckedCheckbox = true;
                $checkbox.checked = false;
            }
        }

        if (hasCheckedCheckbox) {
            this.loadContent(this.formURL, 'POST');
        }
    }

    serializeForm (form) {
        let field;
        const s = [];

        if (typeof form === 'object' && form.nodeName === 'FORM') {
            for (let i = 0; i < form.elements.length; i++) {
                field = form.elements[i];

                if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
                    if (field.type === 'select') {
                        for (let j = form.elements[i].options.length - 1; j >= 0; j--) {
                            if (field.options[j].selected) {
                                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[j].value);
                            }
                        }
                    } else {
                        if ((field.type === 'checkbox') && field.checked) {
                            s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                        } else {
                            if (field.type === 'radio' && field.checked) {
                                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                            } else {
                                if (field.type !== 'radio' && field.type !== 'checkbox') {
                                    s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                                }
                            }
                        }
                    }
                }
            }
        }
        return s.join('&').replace(/%20/g, '+');
    }
}

export { AppOverview };
